import { LABELS } from '@/constants/common/message.constants'

import { type PartnerEntity } from '../../aspida/@types'

/**
 * パートナー種別
 */
export type PartnerType = PartnerEntity['type']

export const PARTNER_TYPE = {
  /** 自社 */
  IN_HOUSE: 'IN_HOUSE',
  /** 契約業者 */
  CONTRACTOR: 'CONTRACTOR'
} as const satisfies Record<PartnerType, PartnerType>

export const PARTNER_TYPE_LABEL = {
  [PARTNER_TYPE.IN_HOUSE]: LABELS.PARTNER_TYPE_IN_HOUSE,
  [PARTNER_TYPE.CONTRACTOR]: LABELS.PARTNER_TYPE_CONTRACTOR
} as const satisfies Record<PartnerType, string>
